<template>
  <div
    class="basic-article-list-box height_fill basic_article_list"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart" v-if="isHover || popConfirmState">
      <my_edit_btn :module="module" :title="$t('widgets_basic_article_classification_index_336')"></my_edit_btn>
      <my_edit_btn
        :module="module"
        tabName="animation"
        :title="$t('widgets_basic_article_classification_edit_330')"
        v-if="isPc"
      ></my_edit_btn>
      <el-popover
        placement="top"
        width="160"
        v-model="minBtnVisible"
        @hide="popoverHide"
        @show="popoverShow"
        v-if="isPc"
      >
        <p>{{$t('widgets_basic_article_list_index_412')}}</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="selectType(item.value)"
            v-for="(item, i) in filter.typeOptions"
            :key="i"
          >{{ item.label }}
          </el-button
          >
        </div>
        <div
          v-if="!(listArr.type_system !== undefined && ['article', 'help', 'case', 'product'].includes(this.$route.name))"
          class="my_close_btn delContent lineControl"
          slot="reference"
          style="border-right: 1px solid #595f65"
        >
          <span class="el-icon-document-add" :title="$t('widgets_basic_article_list_index_413')"></span>
        </div>
      </el-popover>
      <my_close_btn
        :module="module"
        :column="column"
        :moduleIndex="module_index"
        :title="$t('widgets_basic_article_list_index_414')"
        v-if="isPc && !isSystem"
      ></my_close_btn>
    </div>
    <my_title_index :title="pc_widgets_infor.title" v-show="isPc"></my_title_index>
    <my_title_index :title="mb_infor.title" v-show="isMobile"></my_title_index>

    <div class="cate_info" v-if="isSystem && ['article_index', 'case_index', 'help_index', 'download_index', 'video_index'].includes($route.name)" v-show="isPc">
      <h1 class="cate_title condition-cate-title" v-text="(typeName ?typeName : getLang(getAllTitle))"></h1>
       
    </div>
    <div class="cate_summary condition-cate-summary" v-html="typeCont.content_top" v-if="isSystem && pc_widgets_infor.cate_cont_show === 'true'"></div>
    <div
      class="u-list"
      :data-type="pc_widgets_infor.moduleStyle"
      v-if="articleList.length"
    >
      <!-- 第五种轮播图模式 -->
      <template v-if="pc_widgets_infor.moduleStyle == '4' && $store.state.app.view_pattern === 'pc'">
        <div class="basic_article_list_swiper">
          <swiper
            ref="mySwiper"
            class="list_box"
            :options="swiperOption"
            v-if="$store.state.app.basic_article_list_isRender"
          >
            <swiper-slide v-for="(item,i) in articleList" :key="i">
              <basic_article
                :key="i"
                :module="module"
                :data="item"
                :type="pc_widgets_infor.moduleStyle"
                :index="i"
                :show-set="pc_widgets_infor.showSet"
                :img-height="pc_widgets_infor.imgHeight[pc_widgets_infor.imgHeight.radioVal].height"
                :img-width="pc_widgets_infor.imgWidth[pc_widgets_infor.imgWidth.radioVal].width"
                :rol="widgets_infor.colNum[widgets_infor.colNum.radioVal].value"
                @close="articleClose"
                :jump-way="pc_widgets_infor.jumpWay"
                :img-zoom="imgZoom"
                @update="updateArticle"
                data-comb-dom
                :data-col_num="widgets_infor.colNum[widgets_infor.colNum.radioVal].value"
              ></basic_article>
            </swiper-slide>
          </swiper>
          <template v-if="$store.state.app.view_pattern === 'pc' && articleList.length > 1">
            <div class="arrow prev" @click="swiper_prev"></div>
            <div class="arrow next" @click="swiper_next"></div>
          </template>
        </div>
      </template>
      <template v-else>
        <template v-for="(item, i) in articleList">
          <basic_article
            :key="'article' + i"
            :module="module"
            :data="item"
            :type="pc_widgets_infor.moduleStyle"
            :index="i"
            :show-set="pc_widgets_infor.showSet"
            :img-height="pc_widgets_infor.imgHeight[pc_widgets_infor.imgHeight.radioVal].height"
            :img-width="pc_widgets_infor.imgWidth[pc_widgets_infor.imgWidth.radioVal].width"
            :rol="widgets_infor.colNum[widgets_infor.colNum.radioVal].value"
            @close="articleClose"
            :jump-way="pc_widgets_infor.jumpWay"
            :img-zoom="imgZoom"
            @update="updateArticle"
            data-comb-dom
            :data-col_num="widgets_infor.colNum[widgets_infor.colNum.radioVal].value"
          ></basic_article>
          <div
            class="news_list_parting_line"
            :key="i"
            v-if="i < articleList.length - 1 && pc_widgets_infor.moduleStyle !== '1' && pc_widgets_infor.moduleStyle !== '4'"></div>
        </template>
      </template>
    </div>
    <div v-else>
      <div class="news_list_wrap">
        <div class="jz_empty_tips u-box">
          <i class="jz_empty_tips__img"></i>
          <div v-if="listArr.addArticleType == 'label'">
            {{ getLang($t('widgets_basic_article_list_index_416')) }}
          </div>
          <template v-else>
            <div class="jz_empty_tips__text" v-if="!isTypeState && isPc">{{$t('widgets_basic_article_list_index_417')}}</div>
            <div class="jz_empty_tips__text" v-if="!isTypeState && isMobile">{{$t('widgets_basic_article_list_index_418')}}</div>
            <div class="jz_empty_tips__text" v-if="isTypeState">
              {{ getLang($t('widgets_basic_article_list_index_419')) }}
            </div>
            <div
              class="jz_empty_tips__buttons u-btn-gp"
              v-if="!isTypeState && !isMobile"
            >
              <el-popover
                placement="top"
                width="160"
                v-model="visible"
                v-if="['id', 'label'].indexOf(listArr.addArticleType) !==-1"
              >
                <!-- listArr.addArticleType === 'id' -->
                <p>{{$t('widgets_basic_article_list_index_412')}}</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="selectType(item.value)"
                    v-for="(item, i) in filter.typeOptions"
                    :key="i"
                  >{{ item.label }}
                  </el-button
                  >
                </div>
                <el-button type="primary" size="small" slot="reference"
                >{{$t('widgets_basic_article_list_index_413')}}</el-button
                >
              </el-popover>
              <el-button
                type="primary"
                size="small"
                v-if="listArr.addArticleType === 'filter'"
                @click="templet.changeStyle(module, 'style')"
              >{{$t('widgets_basic_article_classification_index_339')}}</el-button
              >
              <my_add_button
                type="articleList"
                :selectIds="listArr.articleList"
                @confirm="selectArticleConfirm"
                :article-type="listArr.type"
                v-if="listArr.addArticleType === 'id'"
              ></my_add_button>
              <el-button
                size="small"
                v-if="listArr.addArticleType === 'filter'"
                @click="basicManagement.popShow = true"
              >{{$t('widgets_basic_article_classification_edit_320')}}</el-button
              >
            </div>
          </template>
        </div>
      </div>
    </div>
    <my_page_index
      v-if="pc_widgets_infor.page.radioValue && formInline.page.total"
      :page="pc_widgets_infor.page"
      :currentPage.sync="formInline.page.currentPage"
      :total="formInline.page.total"
      @change-page="changePage"
    ></my_page_index>

    <div class="cate_summary condition-cate-summary" v-html="typeCont.content" v-if="isSystem && pc_widgets_infor.cate_cont_show === 'true'"></div>

    <basic_addArticle
      :articleType="typeTemporary"
      v-if="showAddArticle"
      @closed="closeAddArticle"
      @submit_sure="submitSure"
    ></basic_addArticle>
    <basic_management
      v-if="basicManagement.popShow"
      :type-tag="listArr.type"
      :show-tag.sync="basicManagement.popShow"
    ></basic_management>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {getArticleListBy1, deleteArtical} from "./../../api/app.js";
import zhToPinyin from "./../../base/zh-to-pinyin";
import basic_article from "./components/basic_article";
import { getBackgroundData, getCommonStyle} from "@/base/widgets_data_compatible";
import {detail_button_style} from '@/base/base'

export default {
  name: "basic_article_list",
  props: {
    module: {
      type: Object,
      default: null,
    },
    column: {
      type: Object,
      default: null,
    },
    row: {
      type: Object,
      default: null,
    },
    module_index: {
      type: Number,
      default: 0,
    },
  },
  components: {
    basic_article
  },
  data() {
    return {
      formInline: {
        channelName: "",
        page: {
          total: 0,
          pageSize: 10,
          currentPage: 1,
        },
      },
      basicManagement: {
        tableData: [],
        popShow: false,
        total: 0,
        proParams: {
          title: i18n.t('widgets_basic_article_classification_edit_320'),
          objectType: "",
          typevalue: 1,
        },
      },
      typeTemporary: "",
      isHover: false,
      popConfirmState: false,
      currentPage: 1,
      articleList: [],
      minBtnVisible: false,
      visible: false,
      showAddArticle: false,
      filter: {
        typeOptions: [
          {
            label: i18n.t('widgets_basic_article_classification_edit_333'),
            value: 1,
          },
          {
            label: i18n.t('widgets_basic_article_classification_edit_334'),
            value: 3,
          },
          {
            label: i18n.t('widgets_basic_article_classification_edit_335'),
            value: 2,
          },
        ],
      },
      requestPage: 0,
      typeId: this.$route.query.typeId !== undefined ? this.$route.query.typeId : '',
      typeName: this.$route.query.name !== undefined ? this.$route.query.name : '',
    };
  },
  computed: {
    getAllTitle(){
      const routeName = this.$route.name
      let name = ''
      switch (routeName) {
        case 'article_index':
          name = '全部文章'
          break;
        case 'case_index':
          name = '全部案例'
          break;
        case 'help_index':
          name = '全部帮助'
          break;
        case 'download_index':
          name = '全部下载'
          break;
        case 'video_index':
          name = '全部视频'
          break;
        default:
          break;
      }
      return name
    },
    widgets_infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    listArr() {
      return this.module.data.listArr;
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    mb_infor() {
      return this.module.data.mb_widgets_infor;
    },
    getList() {
      return this.articleList.sort((a, b) => {
        if (this.listArr.sortBy === "name") {
          if (this.listArr.sort === "desc")
            return (
              zhToPinyin().getCamelChars(a.title).charCodeAt(0) -
              zhToPinyin().getCamelChars(b.title).charCodeAt(0)
            );
          if (this.listArr.sort === "asc")
            return (
              zhToPinyin().getCamelChars(b.title).charCodeAt(0) -
              zhToPinyin().getCamelChars(a.title).charCodeAt(0)
            );
        }
        if (this.listArr.sortBy === "issuingTime") {
          if (this.listArr.sort === "desc")
            return this.$moment(a.date).unix() - this.$moment(b.date).unix();
          if (this.listArr.sort === "asc")
            return this.$moment(b.date).unix() - this.$moment(a.date).unix();
        }
        if (this.listArr.sortBy === "viewing") {
          if (this.listArr.sort === "desc") return a.viewing - b.viewing;
          if (this.listArr.sort === "asc") return b.viewing - a.viewing;
        }
        if (this.listArr.sortBy === "default") return a.index - b.index;
      });
    },
    isMobile() {
      return this.$store.state.app.view_pattern === "mb";
    },
    isPc() {
      return this.$store.state.app.view_pattern === "pc";
    },
    imgZoom() {
      if (this.isPc)
        return this.widgets_infor.backgroundSize.radio_val !== "default"
          ? this.widgets_infor.backgroundSize.custom.backgroundSize
          : this.widgets_infor.backgroundSize.default.backgroundSize;
      if (!this.isPc) return "";
    },
    isTypeState() {
      return this.listArr.moduleState === "type";
    },
    isListState() {
      return this.listArr.moduleState === "list" || !this.listArr.moduleState;
    },
    isSystem() {
      return this.module.data.isSystem === "true";
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      // const num = parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const num = parseInt(infor.colNum[infor.colNum.radioVal].value);
      const slidesPerGroup = parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        loop: slidesPerGroup == 1 ? loop : false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup,//每次翻页个数
        observer: true,
        observeParents: true,
      }
      const autoplay = this.templet.autoplay_obj(
        infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    // 分类简介
    typeCont(){
      let cont = '';
      if(this.typeId){
        let articleTypeList = this.$store.state.app.articleTypeList
        console.log('articleTypeList', articleTypeList);
        for (let i = 0; i < articleTypeList.length; i++) {
          if(this.typeId == articleTypeList[i].id){
            cont = articleTypeList[i]
          }
        }
      }
      return cont;
    }
  },
  watch: {
    listArr: {
      handler(val, oldVal) {
        if (['article', 'help', 'case'].indexOf(this.$route.name) !== -1 && this.listArr.addArticleType === 'label') {  // 添加类型切换 之后 切换了 文章类型 之后重新切换回来标签添加 右侧的标签栏需要重新选择
          let detail = {
            article: 1,
            help: 2,
            case: 3
          }
          this.listArr.type = detail[this.$route.name]
        }
        if (this.pc_widgets_infor.page.pageStyle !== 2) {
          this._getArticle(val)
        } else {
          this.formInline.page.currentPage = 1;
          this._getArticle(val,false,true)
        }
      },
      deep: true,
    },
    "pc_widgets_infor.showNum": {
      deep: true,
      handler(val) {
        this.articleList = [];
        this.formInline.page.currentPage = 1;
        this.formInline.page.pageSize = this.pc_widgets_infor.page.pageSize;
        this._getArticle(this.listArr,false,true)
      }
    },
    "pc_widgets_infor.showAll": {
      deep: true,
      handler(val) {
        this.articleList = [];
        this.formInline.page.currentPage = 1;
        this.formInline.page.pageSize = this.pc_widgets_infor.page.pageSize;
        this._getArticle(this.listArr,false,true)
      }
    },
    "pc_widgets_infor.page": {
      handler(val, oldVal) {
        this.articleList = [];
        this.formInline.page.currentPage = 1;
        this.formInline.page.pageSize = this.pc_widgets_infor.page.pageSize;
        this._getArticle(this.listArr,false,true)
      },
      deep: true,
    },
    '$store.state.myRender.common.theme_color'(val) {
      const fontSize = this.pc_widgets_infor.font[this.pc_widgets_infor.font.radio_val].fontSize
      const buttonStyle = detail_button_style(this.pc_widgets_infor.button_text.styleType,val,fontSize)
      this.$set(this.pc_widgets_infor.button_text, "buttonStyle", buttonStyle);
    },
    'pc_widgets_infor.button_text.styleType'(val) {
      const fontSize = this.pc_widgets_infor.font[this.pc_widgets_infor.font.radio_val].fontSize
      const theme_color = this.$store.state.myRender.common.theme_color
      const buttonStyle = detail_button_style(this.pc_widgets_infor.button_text.styleType,theme_color,fontSize)
      this.$set(this.pc_widgets_infor.button_text, "buttonStyle", buttonStyle);
    },
  },
  created() {
    this.templet.checkShowValue(this.module.data.pc_widgets_infor);
    /*
    // 4.6.7 组合阴影
    if (typeof this.pc_widgets_infor.boxShadow == "undefined") {
      this.$set(this.pc_widgets_infor, "boxShadow", box_shadow_style_add().boxShadow);
    }
    // 4.7.2 简介字数 descNum
    if (this.pc_widgets_infor.descNum === undefined) {
      this.$set(this.pc_widgets_infor, "descNum", 57);
    }
    // 4.7.9 轮播图
    if (!this.pc_widgets_infor.slides_group) {
      this.$set(this.pc_widgets_infor, "slides_group", getSwiperSettingData().slides_group);
      this.$set(this.pc_widgets_infor, "swiper_loop", getSwiperSettingData().swiper_loop);
      this.$set(this.pc_widgets_infor, "banner_set", getSwiperSettingData().banner_set);
    }

    // 4.7.15
    if(typeof this.pc_widgets_infor.cate_cont_show == "undefined"){
      this.$set(this.pc_widgets_infor, 'cate_cont_show', 'true')
    }

    // 4.7.12 文章标题字体
    if (!this.pc_widgets_infor.font) {
      this.$set(this.pc_widgets_infor, "font", fontSet())
    }
    */
   
    // showset新加的 summary, button 默认勾选
    if (typeof this.pc_widgets_infor.showSet == 'undefined') {
      this.$set(this.pc_widgets_infor, 'showSet', ['date', 'type', 'summary', 'button'])
    }
    // let showSet = this.pc_widgets_infor.showSet.concat(['summary', 'button'])
    // this.pc_widgets_infor.showSet = Array.from(new Set(showSet))


    if(this.listArr.type_system !== undefined && this.module.widgets_id > 1000000){
      if(['article', 'help', 'case', 'product'].includes(this.$route.name)){
        // if(['article', 'help', 'case'].includes(this.$route.name)){
        //   let artType = {'article' : '新闻', 'help' : '帮助', 'case' : '案例'}
        //   this.mb_infor.title.text.value = this.pc_widgets_infor.title.text.value = '相关' + artType[this.$route.name]
        // }else if(this.$route.name == 'product'){
        //   this.mb_infor.title.text.value = this.pc_widgets_infor.title.text.value = '相关文章'
        // }
        this.mb_infor.title.text.value = this.pc_widgets_infor.title.text.value = 'Recommend'
        this.mb_infor.title.text.isHidden = this.pc_widgets_infor.title.text.isHidden = false
      }
    }
    if(this.listArr.sys_type === 0){
      let detail = {
        product: 1,
        article: 1,
        help: 2,
        case: 3
      }
      this.listArr.sys_type = detail[this.$route.name]
    }

    // 初始化颜色
    if(this.pc_widgets_infor.button_text.buttonStyle.fontColor == ''){
      const fontSize = this.pc_widgets_infor.font[this.pc_widgets_infor.font.radio_val].fontSize || 16
      const theme_color = this.$store.state.myRender.common.theme_color
      const buttonStyle = detail_button_style(this.pc_widgets_infor.button_text.styleType,theme_color,fontSize)
      this.$set(this.pc_widgets_infor.button_text, 'buttonStyle', buttonStyle);
    }
    

  },
  mounted() {
    this.fixField()
    if (
      this.$route.name === "article_index" ||
      this.$route.name === "help_index" ||
      this.$route.name === "case_index"
    ) {
      if (this.module.data.isSystem === "true") {
        this.listArr.moduleState = "type";
        // this.pc_widgets_infor.page.radioValue = true
        this.listArr.addArticleType = "all";
      }
    }
    if (this.$route.name === "article_index") this.listArr.type = 1;
    if (this.$route.name === "help_index") this.listArr.type = 2;
    if (this.$route.name === "case_index") this.listArr.type = 3;
    // 文章详情 选用标签添加 新闻只能是新闻 案例只能是案例 帮助只能是帮助
    if (['article', 'help', 'case'].indexOf(this.$route.name) !== -1 && this.listArr.addArticleType === 'label') {
      let detail = {
        article: 1,
        help: 2,
        case: 3
      }
      this.listArr.type = detail[this.$route.name]
    }

    this.formInline.page.pageSize = this.pc_widgets_infor.page.pageSize;
    this._getArticle(this.listArr)
    // this.canvas()
  },
  methods: {
    module_isHover(val) {
      this.isHover = val;
    },
    _getArticle(listArr,update = false,reset = false){
      this.getArticle(
        listArr.articleList,
        listArr.filterBy,
        listArr.type,
        this.isTypeState,
        this.pc_widgets_infor.page.pageStyle === 2,
        this.formInline.page.currentPage,
        update,
        reset
      )
    },
    getArticle(ids = [], filter = "id",type = 1,isTypeState = false,isIncrement = false,currentPage = this.formInline.page.currentPage,update = false,reset = false) {
      let query = {
        type: type,
        sort: this.listArr.sortBy === "default" ? "default" : "auto_issue",
        order: this.listArr.sort,
        rows: this.pc_widgets_infor.page.radioValue
          ? this.formInline.page.pageSize
          : "200",
        page: currentPage,
        category_id: this.isSystem ? this.$route.query.typeId || "" : "",
        is_up: "true",
      };
      if (!isTypeState) {
        if (this.listArr.addArticleType === "id") {
          if (!ids.length) {
            this.formInline.page.total = 0;
            return (this.articleList = []);
          }
          query.ids = ids.join(",");
        }
        if (this.listArr.addArticleType === "filter") {
          if (!filter.length) {
            this.formInline.page.total = 0;
            return (this.articleList = []);
          }
          query.category_ids = filter.join(",");
        }
        if (this.listArr.addArticleType === 'label') {
          query.tag_id = this.$route.query.tag_id
          if (['article', 'help', 'case'].indexOf(this.$route.name) !== -1) query.sameId = this.$route.query.id
        }
        if (this.listArr.addArticleType === 'system') {
          query = {
            rows: query.rows ? query.rows : 100,
            page: query.page ? query.page : 1,
            id : this.$route.query.id,
            type : (this.$route.name !== 'product' && this.listArr.sys_type && this.listArr.sys_type > 0) ? this.listArr.sys_type :  ['article', 'help', 'case'].indexOf(this.$route.name) + 1,
            self : this.$route.name == 'product' ? 0 : 1,
            sys_type : (this.listArr.sys_type && this.listArr.sys_type > 0) ? this.listArr.sys_type : 0
          }
        }
      }
      if (this.listArr.addArticleType === 'label' && !this.$route.query.tag_id) {
        this.articleList = [];
        return;
      }
      getArticleListBy1(query, this.listArr.addArticleType).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        if(!res.data.rows){
          res.data.rows= [];
        }
        if (!isIncrement) {
          console.log('res.data.rows', res.data.rows);
          this.articleList = res.data.rows.map((item, i) => {
            const relation_category = item.relation_category || {};
            return {
              id: item.id,
              index: i,
              imgSrc: item.img,
              title: item.title,
              content: item.summary,
              date: this.$moment(item.auto_issue * 1000).format("YYYY-MM-DD"),
              type: relation_category.name || '',
              typeId: relation_category.id,
              viewing: 1566,
              url: item.url,
              _type: item.type,
              tag_ids: item.tag_ids // 这边新增了一个 标签ID
            };
          });
        } else {
          if (update) {
            let replaceStartIndex =
              this.requestPage * this.formInline.page.pageSize -
              this.formInline.page.pageSize;
            let replaceDeleteCount = this.formInline.page.pageSize;
            let replaceArr = [];
            res.data.rows.forEach((item, i) => {
              const relation_category = item.relation_category || {};
              replaceArr.push({
                id: item.id,
                index: i,
                imgSrc: item.img,
                title: item.title,
                content: item.summary,
                date: this.$moment(item.auto_issue * 1000).format("YYYY-MM-DD"),
                type: relation_category.name || '',
                typeId: relation_category.id,
                viewing: 1566,
                url: item.url,
                _type: item.type,
                tag_ids: item.tag_ids // 这边新增了一个 标签ID
              });
            });
            this.articleList.splice(
              replaceStartIndex,
              replaceDeleteCount,
              ...replaceArr
            );
          } else {
            if (reset) {
              this.articleList = [];
            }
            res.data.rows.forEach((item, i) => {
              const relation_category = item.relation_category || {};
              this.articleList.push({
                id: item.id,
                index: i,
                imgSrc: item.img,
                title: item.title,
                content: item.summary,
                date: this.$moment(item.auto_issue * 1000).format("YYYY-MM-DD"),
                type: relation_category.name || '',
                typeId: relation_category.id,
                viewing: 1566,
                url: item.url,
                _type: item.type,
                tag_ids: item.tag_ids // 这边新增了一个 标签ID
              });
            });
          }
        }
        if (!this.pc_widgets_infor.page.radioValue) {
          if (!this.pc_widgets_infor.showAll) {
            this.articleList = this.articleList.slice(0, this.pc_widgets_infor.showNum)
          } else {
            this.articleList = this.articleList.slice(0, 200)
          }
        }
        this.formInline.page.total = res.data.total;
      });
    },
    articleClose(id) {
      this.listArr.articleList = this.listArr.articleList.filter(
        (item) => item !== id
      );
      deleteArtical({
        ids: id,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this._getArticle(this.listArr)        
      });
    },
    selectArticleConfirm(val) {
      this.listArr.articleList = val;
    },
    selectType(type) {
      // this.listArr.type = type
      this.typeTemporary = type;
      this.showAddArticle = true;
    },
    closeAddArticle() {
      this.showAddArticle = false;
    },
    changePage(page) {
      this.formInline.page.currentPage === page;
      this.formInline.page.currentPage = page;
      this.requestPage = this.formInline.page.currentPage;
      this._getArticle(this.listArr)
    },
    updateArticle(id, index) {
      if (this.pc_widgets_infor.page.pageStyle === 2) {
        let page = Math.ceil((index + 1) / this.formInline.page.pageSize);
        this.requestPage = page;
        this.getArticle(
          this.listArr.articleList,
          this.listArr.filterBy,
          this.listArr.type,
          this.isTypeState,
          this.pc_widgets_infor.page.pageStyle === 2,
          this.requestPage,
          true
        );
      } else {
        this._getArticle(this.listArr)
      }
    },
    submitSure(id) {
      this.formInline.page.currentPage = 1;
      if (this.listArr.addArticleType === "filter")
        this.listArr.articleList = [];
      this.listArr.addArticleType = "id";
      this.listArr.articleList.push(id);
      this.listArr.type = this.typeTemporary;
      this._getArticle(this.listArr)      

      if (
        this.$route.name === "article_index" ||
        this.$route.name === "help_index" ||
        this.$route.name === "case_index"
      ) {
        if (this.module.data.isSystem === "true") {
          this.listArr.addArticleType = "all";
        }
      }
    },
    popoverShow() {
      this.popConfirmState = true;
    },
    popoverHide() {
      this.popConfirmState = false;
    },
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    fixField() {
      if (!this.pc_widgets_infor.padding) {
        this.$set(this.pc_widgets_infor, 'padding', {
          radio_val: 'default',
          default: {
            paddingTop: 20,
            paddingLeft: 20,
          },
          custom: {
            paddingTop: 20,
            paddingLeft: 20,
          }
        })
      }
      if (!this.pc_widgets_infor.background) {
        this.$set(this.pc_widgets_infor, "background", getBackgroundData().background);
      }
      // 4.3.16 悬浮背景色的
      // 组合背景 这边颜色 添加悬浮的颜色  首先悬浮颜色 应该只有背景色才会有 是图片的时候不能存在 
      if(this.pc_widgets_infor.background && !this.pc_widgets_infor.background.default.seColor) { // 组合背景存在 并且没有 悬浮的样式 才进行操作
        //  所以 在预览的时候要进行处理 background 不存在的情况 以及 没有seColor 和 存在seColor的情况
        this.$set(this.pc_widgets_infor.background.default, "seColor",this.pc_widgets_infor.background.default.color);
        this.$set(this.pc_widgets_infor.background.custom, "seColor",this.pc_widgets_infor.background.custom.color);
      }
      // 圆角
      if (typeof this.pc_widgets_infor.borderRadius == "undefined") {
        this.$set(this.pc_widgets_infor, "borderRadius", getCommonStyle().borderRadius);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/css/components/basic_article_list";

.basic-article-list-box {
  /*background: #fff;*/
  padding-bottom: 24px;
  width: 100%;
  height: 100%;

  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;

    .my_close_btn:hover {
      background-color: #2e343b;
    }
  }
  .cate_info{
    padding: 10px 10px 0px 10px;
    font-size: 14px;
    .cate_title{
      font-weight: bold;
    }
    .cate_summary{
      margin-top: 10px;
    }
  }
  .u-list {
    background: #fff;

    &[data-type="1"] {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      padding-top: 0;
      padding-bottom: 0;
      font-size: 0;
      background: transparent;
    }

    .news_list_parting_line {
      height: 0;
      border-bottom: 1px solid #ececec;
      margin: 0 1.6666%;
      box-sizing: border-box;
    }
  }



  .jz_empty_tips {
    width: 100%;
    padding: 90px 0;
    text-align: center;
  }

  .jz_empty_tips__img {
    display: block;
    width: 157px;
    height: 123px;
    margin: 0 auto;
    /*background: url(/image/rimage/jz/defaultIcon.png?v=201811211412) 0 0;*/
  }

  .jz_empty_tips__text {
    margin-top: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #333;
  }

  .jz_empty_tips__buttons {
    margin-top: 20px;
  }

  .jz_button__active {
    background-color: #5874d8;
    border-color: #5874d8;
    color: #fff;
    outline: 0;
  }

  .jz_button {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    height: 34px;
    padding: 0 13px;
    border: 1px solid #e3e2e8;
    cursor: pointer;
    user-select: none;
    border-radius: 2px;
    background-color: #fff;
    outline: 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 0;
    color: #333;
    white-space: nowrap;
  }

  .jz_empty_tips__button {
    margin: 0 15px;
  }

  .u-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .u-btn-gp {
    display: flex;
    width: 200px;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_article_list/index.vue